import React from 'react';
import { render, screen, act } from '@testing-library/react';

import Video from '../Video';

// Mock jQuery
const jQueryHandlers = {};
beforeEach(() => {
  global.$ = jest.fn((selector) => ({
    on: jest.fn((event, handler) => {
      jQueryHandlers[`${selector}::${event}`] = handler;
    }),
    off: jest.fn((event) => {
      delete jQueryHandlers[`${selector}::${event}`];
    }),
  }));
});

afterEach(() => {
  Object.keys(jQueryHandlers).forEach(k => delete jQueryHandlers[k]);
});

const makeItem = (videoUrl) => ({
  id: 42,
  settings: { video: videoUrl },
});

describe('Video', () => {
  it('renders a YouTube iframe for a YouTube URL', () => {
    const item = makeItem('https://www.youtube.com/watch?v=dQw4w9WgXcQ');
    const { container } = render(<Video item={item} />);
    const iframe = container.querySelector('iframe');
    expect(iframe).toBeInTheDocument();
    expect(iframe.getAttribute('src')).toBe('https://www.youtube.com/embed/dQw4w9WgXcQ');
  });

  it('renders a Vimeo iframe for a Vimeo URL', () => {
    const item = makeItem('https://vimeo.com/123456789');
    const { container } = render(<Video item={item} />);
    const iframe = container.querySelector('iframe');
    expect(iframe).toBeInTheDocument();
    expect(iframe.getAttribute('src')).toBe('https://player.vimeo.com/video/123456789?portrait=0');
  });

  it('renders container div', () => {
    const item = makeItem('https://www.youtube.com/watch?v=abc123');
    const { container } = render(<Video item={item} />);
    expect(container.querySelector('.p-video-container')).toBeInTheDocument();
  });

  it('updates video via jQuery updateVideo event', () => {
    const item = makeItem('https://www.youtube.com/watch?v=original');
    render(<Video item={item} />);

    // Trigger the updateVideo event via stored handler
    const handler = jQueryHandlers['#item-42::updateVideo'];
    expect(handler).toBeDefined();

    act(() => {
      handler({}, 'https://vimeo.com/999999');
    });

    const iframe = document.querySelector('iframe');
    expect(iframe.getAttribute('src')).toBe('https://player.vimeo.com/video/999999?portrait=0');
  });

  it('clears video when updateVideo receives invalid URL', () => {
    const item = makeItem('https://www.youtube.com/watch?v=abc');
    render(<Video item={item} />);

    const handler = jQueryHandlers['#item-42::updateVideo'];
    act(() => {
      handler({}, 'https://someother.com/video');
    });

    // Should still render the YouTube iframe as default when videoType is null
    // The component renders YouTubeVideo when videoType is not 'vimeo'
    const iframe = document.querySelector('iframe');
    expect(iframe).toBeInTheDocument();
  });

  it('cleans up jQuery handler on unmount', () => {
    const item = makeItem('https://www.youtube.com/watch?v=abc');
    const { unmount } = render(<Video item={item} />);
    expect(jQueryHandlers['#item-42::updateVideo']).toBeDefined();
    unmount();
    expect(jQueryHandlers['#item-42::updateVideo']).toBeUndefined();
  });

  it('handles item with no settings gracefully', () => {
    const item = { id: 1, settings: undefined };
    // setInitialVideoState returns early when no settings
    const { container } = render(<Video item={item} />);
    expect(container.querySelector('.p-video-container')).toBeInTheDocument();
  });
});
